/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_UpdatedInputs */

const en_product_updated = /** @type {(inputs: Product_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product updated`)
};

const es_product_updated = /** @type {(inputs: Product_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producto actualizado`)
};

/**
* | output |
* | --- |
* | "Product updated" |
*
* @param {Product_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const product_updated = /** @type {((inputs?: Product_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_product_updated(inputs)
	return es_product_updated(inputs)
});